module.exports = __webpack_public_path__ + "static/ba5f365ff50d755d09363c7aae2f3a76.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/landing.webm
// module id = 1188
// module chunks = 0